import { createContext, useContext } from 'react';
import { Termin } from '@/domain/termine/shared/types/Termin';
import { Feiertag } from '@/domain/termine/shared/types/Feiertag';
import dayjs from 'dayjs';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';

export interface CalendarContextType {
  feiertage: Feiertag[];
  standortId: string | null;
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  monthDate: { year: number; month: number };
  termineWithRecurrences: Termin[];
  termineByDay: Map<string, Termin[]>;
  colIndex?: number;
  rowIndex?: number;
  kalender: TerminKalender[];
  selectedKalenderIds: string[];
  loading: boolean;
  setSelectedKalenderIds: (ids: string[]) => void;
}

export const CalendarContext = createContext<CalendarContextType | undefined>(
  undefined,
);

export function useCalendarContext() {
  const context = useContext(CalendarContext);
  if (!context) {
    throw new Error('useCalendarContext must be used within CalendarProvider');
  }
  return context;
}
